import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=5a0f6514&scoped=true&"
import script from "./VideoSection.vue?vue&type=script&lang=ts&"
export * from "./VideoSection.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=5a0f6514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f6514",
  null
  
)

export default component.exports